import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 24 }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} width={dimension} height={dimension} viewBox="0 0 24 24" fill="none">
  <mask id="mask0_18933_1480" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_18933_1480)">
    <path d="M10 18L4 12L10 6L11.4 7.45L7.85 11H20V13H7.85L11.4 16.55L10 18Z" fill="#333333"/>
  </g>
</svg>
);

export default Icon;
